import React, { useState, useEffect } from "react";
import { ArrowUpRight } from "lucide-react";
import { galleryProjects, galleryCategories } from "../mock";
import { Reveal } from "../hooks/useReveal";

export default function Projects() {
  const [filter, setFilter] = useState("All");

  useEffect(() => { window.scrollTo({ top: 0 }); }, []);

  const items =
    filter === "All"
      ? galleryProjects
      : galleryProjects.filter((p) => p.category === filter);

  return (
    <main className="bg-[var(--cream)]" style={{ backgroundColor: "var(--cream)" }}>
      {/* header */}
      <section className="pt-40 md:pt-48 pb-14 md:pb-20">
        <div className="max-w-[1500px] mx-auto px-6 md:px-10">
          <p className="font-sans-ui tracking-wide-2 text-[0.66rem] uppercase mb-6" style={{ color: "var(--teal)" }}>
            Selected work
          </p>
          <h1 className="font-serif-display text-[3rem] md:text-[5rem] leading-[1.02] font-300 text-[var(--navy)]" style={{ color: "var(--navy)" }}>
            Projects
          </h1>
          <p className="mt-6 max-w-2xl text-[var(--muted)] text-base md:text-lg" style={{ color: "var(--muted)" }}>
            A selection of residential, workplace, retail and commercial spaces designed and delivered by South Sea Design Studio.
          </p>

          {/* filters */}
          <div className="mt-12 flex flex-wrap gap-3">
            {galleryCategories.map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                className="font-sans-ui tracking-wide-3 text-[0.66rem] uppercase px-5 py-2.5 border transition-all duration-400"
                style={{
                  borderColor: filter === c ? "var(--navy)" : "rgba(22,50,79,0.2)",
                  backgroundColor: filter === c ? "var(--navy)" : "transparent",
                  color: filter === c ? "var(--cream)" : "var(--navy)",
                }}
              >
                {c}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* grid */}
      <section className="pb-28">
        <div className="max-w-[1500px] mx-auto px-6 md:px-10">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {items.map((p, i) => (
              <Reveal key={p.id} delay={(i % 3) * 90}>
                <div className="group cursor-pointer">
                  <div className="img-zoom relative aspect-[4/5]">
                    <img src={p.image} alt={p.title} className="h-full w-full object-cover" />
                    <div className="absolute inset-0 transition-opacity duration-500 opacity-0 group-hover:opacity-100" style={{ background: "linear-gradient(180deg, rgba(14,35,56,0) 45%, rgba(14,35,56,0.6) 100%)" }} />
                    <div className="absolute top-5 right-5 h-11 w-11 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-2 group-hover:translate-y-0" style={{ backgroundColor: "var(--cream)" }}>
                      <ArrowUpRight size={18} strokeWidth={1.5} style={{ color: "var(--navy)" }} />
                    </div>
                  </div>
                  <div className="pt-5 flex items-start justify-between">
                    <div>
                      <h3 className="font-serif-display text-xl md:text-2xl text-[var(--navy)]" style={{ color: "var(--navy)" }}>{p.title}</h3>
                      <p className="mt-1 font-sans-ui tracking-wide-3 text-[0.6rem] uppercase" style={{ color: "var(--teal)" }}>{p.category} · {p.location}</p>
                    </div>
                    <span className="font-sans-ui text-sm text-[var(--muted)]" style={{ color: "var(--muted)" }}>{p.year}</span>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
